import home from './home'
import plan from './plan'
import record from './record'
import report from './report'
import userCenter from './userCenter'
// import repair from './repair'
import mend from './mend'
import register from './register'
import customer from './customer'
import contract from './contract'
import onlineTest from './onlineTest'
import serverOrder from './serverOrder'
import examine from './examine'
import projectAuthorization from './projectAuthorization'
import device from './device'
import team from './team'       // 团队
import myMessage from './myMessage'       // 消息
import project from './project'       // (项目旧模块有些接口还在用)


export default {
    home,
    report,
    plan,
    record,
    userCenter,
    // repair,
    mend,
    register,
    customer,
    contract,
    onlineTest,
    serverOrder,
    examine,
    projectAuthorization,
    device,
    team,
    myMessage,
    project
}



// WEBPACK FOOTER //
// ./src/api/modules/ems/index.js